
import { useCallback, useEffect, useMemo, useState } from "react";
import { DataTable } from "../../dataTables/data-table"
import { deteleUser, fetchUsers } from "@/apiCalls/apiCalls";
import { Button } from "@/components/ui/button";
import Spinner from "../spinnner/Spinner";
import { Users, usersColumns } from "@/pages/users/UsersColumns";
import AddUserDrawer from "./AddUserDrawer";
import UpdateUserDrawer from "./UpdateUserDrawer";
import { errorNotification, successNotification } from "@/utils/Notification";
import { jwtDecode } from "jwt-decode"
import useAuth from "@/hooks/useAuth";
import { UsersDataTables } from "./UsersDataTables";
import { useLocation, useNavigate } from "react-router-dom";
import useAxiosPrivate from "@/context/UseAxiosPrivate";
import axios from "axios";
import ChangePasswordDrawer from "./ChangePasswordDrawer";


export default function UsersFn() {
    const [data, setData] = useState<Users[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [showAddUserDrawer, setShowAddUserDrawer] = useState(false)
    const [showUpdateUserDrawer, setShowUpdateUserDrawer] = useState(false)
    const [showchangePasswordDrawer, setchangePasswordDrawer] = useState(false)
    const [userData, setUserData] = useState<Users | undefined>(undefined)
    const { auth } = useAuth()
    let token: any = auth.accessToken
    const decoded: any = jwtDecode(token);
    let roles: string[] = decoded.UserInfo.roles
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate()


    const getUsers = () => {
        setLoading(true)
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/users', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: Users[]) => {
                if (isMounted) {
                    setData(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            }).finally(() => {
                setLoading(false)
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    useEffect(() => {
        getUsers()
    }, [])

    const getClientIPAndURL = async () => {
        try {
            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }

    const deleteUserById = (userId: any) => {
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.delete(`/api/v1/users/${userId}`, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then((data: any) => {
            if (isMounted) {
                successNotification(
                    "assets successfully deleted",
                    "asset deleted",
                    'topRight'
                )

            }
            getUsers()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    const editFunctionCall = (users: Users) => {
        setUserData(users)
        setShowUpdateUserDrawer(!showUpdateUserDrawer)
    }
    const changePasswordFunctionCall = (users: Users) => {
        setUserData(users)
        setchangePasswordDrawer(!showchangePasswordDrawer)
    }

    const deleteFunctionCall = async (users: Users) => {
        deleteUserById(users.id)
    }


    const onDelete = useCallback(
        (users: Users) => deleteFunctionCall(users),
        []
    )

    const onEdit = useCallback(
        (users: Users) => editFunctionCall(users),
        []
    )
    const onChangePassword = useCallback(
        (users: Users) => changePasswordFunctionCall(users),
        []
    )


    const AssetColumnsData = useMemo(() => usersColumns({ onEdit, onDelete, onChangePassword, roles }), [])


    if (loading) {
        return <Spinner />
    }

    return (
        <main className='mx-3 mt-16 sm:ml-[300px] sm:mt-3'>

            {roles.includes('user-create') && (
                <Button
                    variant='default'
                    className="flex items-center justify-end"
                    onClick={() => setShowAddUserDrawer(!showAddUserDrawer)}
                >
                    create user
                </Button>
            )}
            <UsersDataTables columns={AssetColumnsData} data={data} filterNameColumn="uuid" />

            {roles.includes('user-create') && showAddUserDrawer && (
                <AddUserDrawer
                    showAddUserDrawer={showAddUserDrawer}
                    setShowAddUserDrawer={setShowAddUserDrawer}
                    getUsers={getUsers}
                />
            )}
            {userData && roles.includes('user-edit') && (
                <UpdateUserDrawer
                    showUpdateUserDrawer={showUpdateUserDrawer}
                    setShowUpdateUserDrawer={setShowUpdateUserDrawer}
                    Users={userData}
                    getUsers={getUsers}
                    setUserData={setUserData}
                />
            )}
            {userData && roles.includes('user-edit') && (
                <ChangePasswordDrawer
                    showchangePasswordDrawer={showchangePasswordDrawer}
                    setchangePasswordDrawer={setchangePasswordDrawer}
                    Users={userData}
                    getUsers={getUsers}
                    setUserData={setUserData}
                />
            )}
        </main>
    )
}